import React from 'react';
import { useLanguage } from './LanguageContext';
import { ChefHat } from 'lucide-react';

export const Navbar = () => {
  const { lang, toggleLang, t } = useLanguage();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <header
      data-testid="site-navbar"
      className="sticky top-0 z-50 w-full backdrop-blur-xl bg-[#FFFDF8]/75 border-b border-stone-200/50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          <span className="relative h-9 w-9 rounded-2xl bg-orange-500 flex items-center justify-center shadow-[0_8px_20px_-8px_rgba(249,115,22,0.6)] transition-transform group-hover:rotate-[-6deg]">
            <ChefHat className="h-5 w-5 text-white" strokeWidth={2.4} />
          </span>
          <span className="font-display font-extrabold text-lg tracking-tight text-stone-900">
            MealMatcher
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8 text-sm font-semibold text-stone-700">
          <button
            data-testid="nav-features"
            onClick={() => scrollTo('features')}
            className="hover:text-orange-600 transition-colors"
          >
            {t.nav.features}
          </button>
          <button
            data-testid="nav-gallery"
            onClick={() => scrollTo('gallery')}
            className="hover:text-orange-600 transition-colors"
          >
            {t.nav.gallery}
          </button>
          <button
            data-testid="nav-faq"
            onClick={() => scrollTo('faq')}
            className="hover:text-orange-600 transition-colors"
          >
            {t.nav.faq}
          </button>
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="lang-toggle"
            onClick={toggleLang}
            aria-label="Toggle language"
            className="flex items-center gap-0 rounded-full border border-stone-200 bg-white p-1 text-xs font-bold"
          >
            <span
              className={`px-2.5 py-1 rounded-full transition-all ${
                lang === 'no' ? 'bg-stone-900 text-white' : 'text-stone-500'
              }`}
            >
              NO
            </span>
            <span
              className={`px-2.5 py-1 rounded-full transition-all ${
                lang === 'en' ? 'bg-stone-900 text-white' : 'text-stone-500'
              }`}
            >
              EN
            </span>
          </button>
          <button
            data-testid="nav-cta"
            onClick={() => scrollTo('cta')}
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-orange-500 text-white text-xs font-bold hover:bg-orange-600 transition-colors active:scale-95"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-white animate-pulse" />
            {t.nav.comingSoon}
          </button>
        </div>
      </div>
    </header>
  );
};
